var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPopover = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 3.06l-.823.824a1.25 1.25 0 0 1-.884.366H4a.25.25 0 0 0-.25.25v8c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-8a.25.25 0 0 0-.25-.25H9.707a1.25 1.25 0 0 1-.884-.366L8 3.06zm-.884-1.237a1.25 1.25 0 0 1 1.768 0l.927.927H12c.966 0 1.75.783 1.75 1.75v8A1.75 1.75 0 0 1 12 14.25H4a1.75 1.75 0 0 1-1.75-1.75v-8c0-.967.784-1.75 1.75-1.75h2.19l.926-.927z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPopover);
export default ForwardRef;